export function unsubscribeToNotification(topic: string) {
    (window.webkit as any).messageHandlers.unsubscribeFromNotifications.postMessage(
        topic, 
        () => {
            // no-op
        }
    );
}